<template>
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
        <path d="M6.75 13c-.414 0-.75-.448-.75-1s.336-1 .75-1h10.5c.414 0 .75.448.75 1s-.336 1-.75 1H6.75z"
              fill-rule="evenodd"></path>
    </svg>
</template>
